import { render, staticRenderFns } from "./HbLink.vue?vue&type=template&id=25e6986d&scoped=true&"
import script from "./HbLink.vue?vue&type=script&lang=js&"
export * from "./HbLink.vue?vue&type=script&lang=js&"
import style0 from "./HbLink.vue?vue&type=style&index=0&id=25e6986d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25e6986d",
  null
  
)

export default component.exports